import { FC } from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

import styles from './CountryTabs.module.scss';
import { DestinationCountry } from '../../../../../../types/trip.types';

interface CountryTabsProps {
  countries: DestinationCountry[];
  selectedCountryId: number;
  onCountryChange: (countryId: number) => void;
}

const CountryTabs: FC<CountryTabsProps> = ({ countries, selectedCountryId, onCountryChange }) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newCountryId: number | null) => {
    if (newCountryId !== null) {
      onCountryChange(newCountryId);
    }
  };

  if (countries.length === 0) {
    return null;
  }

  return (
    <Box className={styles.tabsContainer}>
      <ToggleButtonGroup
        value={selectedCountryId}
        exclusive
        onChange={handleChange}
        className={styles.toggleGroup}
      >
        {countries.map(country => (
          <ToggleButton
            key={country.id}
            value={country.id}
            className={`${selectedCountryId === country.id && styles.selected} ${styles.toggleButton}`}
          >
            <Typography variant="h11Semibold">{country.name}</Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default CountryTabs;
